import { Component, OnDestroy } from '@angular/core';
import { NavController,AlertController,ToastController,ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { provider } from '../../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { MenuPage } from '../../menu/menu';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

@Component({
  selector: 'page-customerEdit',
  templateUrl: 'customerEdit.html'
})
export class CustomerEditPage implements OnDestroy {
  restaurant: any;
  tessere = [];
  registrazione = false;
  private form : FormGroup;
  city = {name:'',cap:'',province:'',provinceInitials:'',region:'',country:''};
  login = {username:'',password:''};
  customerInfo = {email:'',firstName:'',lastName:'',lotteryCode:''};
  regions = ['Abruzzo','Basilicata','Calabria','Campania','Emilia-Romagna','Fruli-Venezia Giulia','Lazio','Liguria','Lombardia','Marche','Molise','Piemonte','Puglia','Sardegna','Sicilia','Toscana','Trentino-Alto Adige','Umbria','Valle d\'Aosta','Veneto'];
  validation = {
    'email': [{ type: 'compose', message: 'Inserire un\'email valida' },{ type: 'required', message: 'Campo Obbligatorio!' }]
  }
  provinces;
  cities;
  url: string;
  items;
  private _onDestroy = new Subject();

  constructor(public navCtrl: NavController,
              public translateService: TranslateService,
              public storage: Storage,
              public toastCtrl: ToastController,
              public alertCtrl: AlertController,
              public provider: provider,
              public viewCtrl: ViewController,
              private formBuilder: FormBuilder,
              public http: HttpClient,
              public customizer: CustomizerProvider) {
    
    this.url = provider.getUrl();  
    
    this.storage.get('customer').then((customer) => {
      this.customerInfo = JSON.parse(customer);
    });
    
    this.form = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      lotteryCode: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(8)])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
    }); 
  }

  GOTOchangePsw() {

    let prompt = this.alertCtrl.create({
      title: 'Vuoi cambiare la password?',
      message: "Inserisci una nuova password",
      inputs: [
        {name: 'password', placeholder: 'Password', type: 'password'},
        {name: 'confirmPassword', placeholder: 'Conferma Password', type: 'password'}
      ],
      buttons: [
        { text: 'Annulla' },
        {
          text: 'Salva',
          handler: data => {
            if (data.password != data.confirmPassword) {
              let toast = this.toastCtrl.create({
                message: 'Errore! Le password inserite non coincidono',
                duration: 3000,
                position: 'middle'
              });
              toast.present().then(() => {
                this.GOTOchangePsw();
              });
            }
            else {
              this.provider.changePassword((<any>this.customerInfo)._id, data).takeUntil(this._onDestroy).subscribe(data => {
                this.provider.getCustomer((<any>this.customerInfo)._id).takeUntil(this._onDestroy).subscribe(data => {
                  let toast = this.toastCtrl.create({
                    message: 'La password è stata cambiata',
                    duration: 3000,
                    position: 'middle'
                  });
                  toast.present();
                  this.storage.set('customer', (<any>data)._body);
                }, err => {
                  let toast = this.toastCtrl.create({
                    message: 'Errore! Qualcosa è andato storto',
                    duration: 3000,
                    position: 'middle'
                  });
                  toast.present();
                });
              }, err => {
                let toast = this.toastCtrl.create({
                  message: 'Errore! Qualcosa è andato storto',
                  duration: 3000,
                  position: 'middle'
                });
                toast.present();
              });
            }
            /**/
          }
        }
      ]
    });
    prompt.present();
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  edit() {
    let account = {
      addresses: (<any>this.customerInfo).addresses,
      email: this.form.value.email,
      firstName: this.form.value.firstName,
      lastName: this.form.value.lastName,
      lotteryCode: this.form.value.lotteryCode,
      id: (<any>this.customerInfo)._id
    };
    this.provider.edit(account).takeUntil(this._onDestroy).subscribe(() => {
      this.provider.getCustomer(account.id).takeUntil(this._onDestroy).subscribe(data => {
        let toast = this.toastCtrl.create({
          message: 'Le modifiche sono state salvate!',
          duration: 3000,
          position: 'middle'
        });
        toast.present();
        this.storage.set('customer', (<any>data)._body);
      }, err => {
        let toast = this.toastCtrl.create({
          message: 'Errore! Qualcosa è andato storto',
          duration: 3000,
          position: 'middle'
        });
        toast.present();
      });
    }, err => {
      let toast = this.toastCtrl.create({
        message: 'Errore! Qualcosa è andato storto',
        duration: 3000,
        position: 'middle'
      });
      toast.present();
    });
  }

  delete() {
    this.provider.delete((<any>this.customerInfo)._id).takeUntil(this._onDestroy).subscribe(data => {
      this.storage.remove('customer');
      this.navCtrl.push(MenuPage);
    }, err => {
      let toast = this.toastCtrl.create({
        message: 'Errore! Qualcosa è andato storto',
        duration: 3000,
        position: 'middle'
      });
      toast.present();
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/customerEdit/customerEdit.ts